<template>
    <div>
        <Modal
            v-model="isShow"
            class="leverage"
            class-name="vertical-center-modal"
            :title="$t('modifyLeverage')"
            :mask-closable="false"
            footer-hide
            width="500"
            @on-ok="ok"
            @on-cancel="cancel">
            <div class="">
                <Form :model="openModel" class="loginForm" ref="loginForm" > 
                    <FormItem prop="email"  >
                        <effect-input :label='$t("trading_account")' ref="effectInput" v-model="openModel.check1"></effect-input>
                    </FormItem>
                    <FormItem  prop="password">
                        <effect-select :label='$t("leveragelist")' ref="effectInput" v-model="openModel.check2"></effect-select>
                    </FormItem>
                    <FormItem style="text-align:center;">
                        <Button type="primary"  @click="">{{$t('save')}}</Button>
                        <Button type="primary"  @click="">{{$t('close')}}</Button>
                    </FormItem>
                </Form>
            </div>
        </Modal>
    </div>
</template>
<script>
import EffectInput from '@/components/EffectInput.vue';
import EffectSelect from '@/components/EffectSelect.vue';
    export default {
        components: {
            EffectInput, EffectSelect
        },
        props: {
            openDialog: {
                type: Boolean,
                default: false
            }
        },
        data () {
            return {
                isShow: this.openDialog,
                openModel:{
                    check1:'',
                    check2:''
                },
            }
        },
        created(){
            
        },
        watch: {
            openDialog (value) {
                // console.log(value)
                this.isShow = value
            },
        },
        methods: {
            ok () {
                this.$Message.info('Clicked ok');
            },
            cancel () {
                this.$emit('closeDialogLeverage',false)
                // this.$Message.info('Clicked cancel');
            },
            inputFocus () {
                this.$refs.span.setAttribute("class", "active")
            }
        }
    }
</script>
<style lang="less" >
    .leverage{
        .ivu-form-item-content{
            p{
                color: #8b8b8c;
            }
        }
    }
</style>